import { isTrueValue } from "@utils/utilsValidators";

export function buildCoursePayload(
  inputForm: Record<string, any>,
): Record<string, any> {
  let objToSend: Record<string, any> = {
    // === Campi principali ===
    title: inputForm.title || "",
    description: inputForm.description || "",
    detail_description: inputForm.detail_description || "",
    note: inputForm.note || "",
    complexity: inputForm.complexity || null,
    learning_purpose: inputForm.learning_purpose || null,
    cover_id: inputForm.cover_id || undefined,
    video_id: inputForm.video_id || undefined,
    specializations: inputForm.specializations || "NONE",
    structure: inputForm.structure ?? [],
    completion_criteria_lo_required:
      inputForm.completion_criteria_lo_required === true,
    duration: inputForm.duration || null,
    certificate_ids: inputForm.certificate_ids || [],
    is_standalone: isTrueValue(inputForm.is_standalone),

    completable_flag: String(isTrueValue(inputForm.completable_flag) || false),
    time_slots: inputForm.time_slots ?? [],
    stakeholders: inputForm.stakeholders ?? [],
    signature_certificate_ids: inputForm.signature_certificate_ids || [],
    propaedeutic_logics: inputForm.propaedeutic_logics || null,
    completable: isTrueValue(inputForm.completable),
    expected_compl_time: +inputForm.expected_compl_time || undefined,
    publish_date: inputForm.publish_date || null,
    obsolescent_date: inputForm.obsolescent_date || null,
    expiration_date: inputForm.expiration_date || null,
    soft_expiring: !(isTrueValue(inputForm.soft_expiring) || false),
    highlight_for_you: isTrueValue(inputForm.highlight_for_you) || false,
    highlight_explore: isTrueValue(inputForm.highlight_explore) || false,
    didactical_material: inputForm.didactical_material || [],
    badge_id: inputForm.badge_id || null,
    score: +inputForm.score || undefined,
    persona:
      inputForm?.persona?.map((el: any) => el.value?.toUpperCase()) || [],
    format: inputForm.format || null,
    test_id: +inputForm.test_id || null,
    survey_id: Number(inputForm.survey_id) || undefined,
    test_logic: inputForm.test_logic || null,
    test_min_score: inputForm.test_min_score ?? undefined,
    max_attempt: +inputForm.max_attempt || null,
    fixed_expiration: isTrueValue(inputForm.fixed_expiration) || false,
    useful_links: inputForm.useful_links,
    knowledge_domain: inputForm.knowledge_domain || null,
    digited_code: inputForm.digited_code || null,
    // ECM / persona / lecturers / ecc. → defaults (v2 non li gestisce oggi).
    toj_specialization: inputForm.specializations === "TOJ",
    ecm_specialization: inputForm.specializations === "ECM",
    event_start_date: inputForm.event_start_date || null,
    event_end_date: inputForm.event_end_date || null,
    event_credits: Number(inputForm.event_credits) || null,
    training_goal: inputForm.training_goal || null,
    event_training_type: inputForm.event_training_type || null,
    special_cases: inputForm.special_cases || null,
    tutors: inputForm.tutors ?? [],
    teachers: inputForm.teachers ?? [],
    lecturers: inputForm.lecturers ?? [],
    moderators: inputForm.moderators ?? [],
    scientific_managers: inputForm.scientific_managers ?? [],
    // uno solo dei 4 viene mandato
    lo_to_complete: inputForm.lo_to_complete,
    min_completition_perc: inputForm.min_completition_perc,
    completition_minutes: inputForm.completition_minutes,
    completition_minutes_perc: inputForm.completition_minutes_perc,
    // Step 2 (info aggiuntive) campi opzionali non sempre presenti in v1.
    credits: inputForm.credits,
    lo_tag: inputForm.lo_tag ?? [],
  };

  const resetStandaloneItems = {
    publish_date: null,
    obsolescent_date: null,
    expiration_date: null,
    soft_expiring: null,
    highlight_for_you: null,
    highlight_explore: null,
    fixed_expiration: null,
    expected_compl_time: 1,
    stakeholders: [],
    time_slots: [],
  };
  if (!isTrueValue(inputForm.is_standalone)) {
    objToSend = { ...objToSend, ...resetStandaloneItems };
  }

  const resetExpirationFlag = {
    expiration_date: 253402214400000,
    soft_expiring: true,
    fixed_expiration: true,
    expected_compl_time: 1,
  };
  if (!isTrueValue(inputForm.expiration_date_flag)) {
    objToSend = { ...objToSend, ...resetExpirationFlag };
  }

  if (!objToSend.obsolescent_date) {
    objToSend.obsolescent_date = "9999-12-31";
  }

  if (objToSend.useful_links == null) {
    delete objToSend.useful_links;
  }
  if (objToSend.survey_id === undefined) {
    delete objToSend.survey_id;
  }
  if (objToSend.test_min_score === undefined) {
    delete objToSend.test_min_score;
  }
  if (objToSend.credits === undefined || objToSend.credits === "") {
    delete objToSend.credits;
  }

  (
    [
      "lo_to_complete",
      "min_completition_perc",
      "completition_minutes",
      "completition_minutes_perc",
    ] as const
  ).forEach((k) => {
    if (objToSend[k] === undefined) delete objToSend[k];
  });

  return objToSend;
}
